import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';

declare var loadEloquaForm: any;

@Component({
  selector: 'app-contact-sales',
  templateUrl: './contact-sales.component.html',
  styleUrls: ['./contact-sales.component.scss'],
  standalone: false,
})
export class ContactSalesComponent {
  @Input() id: string;
  @Input() name: string;
  @Input() title: string = 'Start Learning with Education';
  @Input() description: string =
    'Whether you are a long-time Genesys customer or new to the Genesys ecosystem, a learning subscription is a great way to maximize your time and budget for continuous learning while also giving you the knowledge needed to become a subject matter expert on the Genesys platform. Each learning subscription provides individual users with access to the top training and certifications for each platform for one year.';
  @Input() actionLabel: string;
  @Input() showButton = true;

  @Input() heroImageCss: string;
  @Input() alignContentCss: string;
  @Input() displayCss: string;
  @Input() formType: string;
  @Input() redirectUrl: string;
  contactSalesForm = environment.beyond.featureFlags.contactSalesForm;

  /**
   * Reset the Form again after user has to click the "x" to close this modal
   * @param isClicked handle event emited from modal
   */
  resetForm(isClicked: boolean): void {
    if (isClicked) {
      if (document.getElementById('eloqSuccessQuoteModal')) {
        loadEloquaForm(this.formType);
      }
    }
  }
}
